import React, { Component } from '../../lib/react';
import { Layout, Button } from 'antd';

import FilterPanel from "../../components/Modules/FilterPanel";
import PageHeader from "../../components/Modules/PageHeader";
import Feed from '../Feed';
import AskForLogin from '../../components/Modules/AskForLogin';

const { Content } = Layout;

export default class SavedEvents extends Component {

  state = {
    userClaims: {},
    visibleRegistration: false,
    visibleAuth: true,
    activeType: 'auth'
  };

  getCaption() {
    const reg = /[_/]/ig;
    return this.props.location.pathname.replace(reg, " ")
  }

  setStateHandler = (obj) => {
    this.setState(obj)
  }

  render() {
    const { events, user } = this.props;
    const { savedEvents } = user;

    const filteredEvents = savedEvents && events && events.filter(function(event){
      return this.indexOf(event.id) >= 0
    }, savedEvents);

    let page = (
      <Layout className="page-wrapper">
        <Content className="feed">
          <PageHeader
            className="header"
            title="Saved Events"
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Event search"
                  type="event"
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Event search"
            mobileTypeSearch="event"
          />

          { filteredEvents && (
              <Feed
                list={filteredEvents}
                location ={ this.props.location }
                getCaption={this.getCaption}
                renderType={"events"}
                eventType={"all"}
              />
            )
          }
        </Content>
      </Layout>
    );
    if (!this.props.user || !this.props.user.uid) {
      page = (
        <React.Fragment>
          <PageHeader
            className="header"
            title="Saved Events"
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Event search"
                  type="event"
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Event search"
            mobileTypeSearch="event"
          />
          <div className="container">
            <AskForLogin
              page="Saved Events"
            />
          </div>
        </React.Fragment>
      )
    }

    return page;
  }
}



// WEBPACK FOOTER //
// ./src/pages/SavedEvents/index.js